import React from 'react';
import PackageCard from '../components/PackageCard';
import BeforeYouBook from '../components/BeforeYouBook';
import { Helmet } from 'react-helmet-async';
const AdditionalLessonsPage = () => {
  const additionalPackages = [{
    title: 'Refresher Driving Lessons',
    price: '£90',
    description: '£45 per hour - 2-hour package designed for full licence holders.',
    features: ['Rebuild confidence after a break from driving', 'Update your skills with current best practices', 'Address specific driving anxieties or concerns', 'Personalized coaching based on your needs'],
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }, {
    title: 'Motorway Driving Lessons',
    price: '£90',
    description: '£45 per hour - 2-hour package for safe motorway driving.',
    features: ['Learn proper lane discipline and positioning', 'Practice safe entry and exit via slip roads', 'Develop skills for overtaking and speed management', 'Build confidence on high-speed roads'],
    popular: true,
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }, {
    title: 'Driving Test Booking Service',
    price: '£110',
    description: 'For Northampton Driving School students only. Includes DVSA test fee (£62).',
    features: ['Administrative handling of test booking', 'Securing available test dates', 'Email confirmation of booking', 'DVSA test fee (£62) included'],
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }];
  return <div className="bg-white" data-id="element-427">
      <Helmet data-id="element-428">
        <title data-id="element-429">Refresher & Motorway Driving Lessons Northampton</title>
        <meta name="description" content="Build confidence with refresher driving lessons, motorway lessons, and driving test booking services. Affordable, local, and tailored to your needs." data-id="element-430" />
        <meta name="keywords" content="refresher driving lessons Northampton, motorway driving lessons Northampton, driving test booking Northampton, confidence building driving lessons, driving test booking help Northampton, book DVSA test help Northampton" data-id="element-431" />
      </Helmet>
      <div className="container mx-auto px-4 py-12" data-id="element-432">
        <h1 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-433">
          Additional Driving Lessons
        </h1>
        {/* Hidden H2 tags for SEO */}
        <h2 className="sr-only" data-id="element-434">Refresher Driving Lessons Northampton</h2>
        <h2 className="sr-only" data-id="element-435">Motorway Driving Lessons Northampton</h2>
        <h2 className="sr-only" data-id="element-436">Driving Test Booking Service Northampton</h2>
        <div className="mb-8" data-id="element-437">
          <p className="text-gray-700" data-id="element-438">
            Beyond our standard and intensive courses, we offer specialized
            driving lessons to help you build confidence in specific areas or
            prepare for your driving test. All lessons are conducted in
            automatic cars by our qualified instructors.
          </p>
        </div>
        {/* Refresher Lessons Section */}
        <div className="mb-16" data-id="element-439">
          <h2 className="text-2xl font-bold mb-6 border-b border-gray-200 pb-2" data-id="element-440">
            Refresher Driving Lessons
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-441">
            <div data-id="element-442">
              <p className="mb-4" data-id="element-443">
                Our refresher driving lessons are perfect for licensed drivers
                who haven't been behind the wheel for a while or who want to
                brush up on their skills. Whether you've lost confidence or
                simply need to update your knowledge of current road
                regulations, our patient instructors will help you become a
                confident driver again.
              </p>
              <div className="bg-gray-50 p-6 rounded-lg" data-id="element-444">
                <h3 className="text-xl font-semibold mb-3" data-id="element-445">Who Can Benefit?</h3>
                <ul className="space-y-2" data-id="element-446">
                  <li className="flex items-start" data-id="element-447">
                    <div className="mr-2 text-burgundy-600 mt-1" aria-hidden="true" data-id="element-448">
                      ✓
                    </div>
                    <div data-id="element-449">Drivers who haven't driven for an extended period</div>
                  </li>
                  <li className="flex items-start" data-id="element-450">
                    <div className="mr-2 text-burgundy-600 mt-1" aria-hidden="true" data-id="element-451">
                      ✓
                    </div>
                    <div data-id="element-452">
                      Those who've experienced a road incident and need to
                      rebuild confidence
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-453">
                    <div className="mr-2 text-burgundy-600 mt-1" aria-hidden="true" data-id="element-454">
                      ✓
                    </div>
                    <div data-id="element-455">
                      International license holders adapting to UK roads
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-456">
                    <div className="mr-2 text-burgundy-600 mt-1" aria-hidden="true" data-id="element-457">
                      ✓
                    </div>
                    <div data-id="element-458">
                      Drivers wanting to improve specific skills (parking,
                      roundabouts, etc.)
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div data-id="element-459">
              <PackageCard title="Refresher Driving Lessons" price="£90" description="£45 per hour - 2-hour package designed for full licence holders who want to rebuild confidence or update their skills." features={['Personalized to address your specific concerns', 'Focus on areas where you need most practice', 'Update on current road rules and regulations', 'Flexible scheduling to fit your availability']} link="https://www.totaldrive.app/a/enquiry_form.php?17584722727972" data-id="element-460" />
            </div>
          </div>
        </div>
        {/* Motorway Lessons Section */}
        <div className="mb-16" data-id="element-461">
          <h2 className="text-2xl font-bold mb-6 border-b border-gray-200 pb-2" data-id="element-462">
            Motorway Driving Lessons
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-463">
            <div data-id="element-464">
              <p className="mb-4" data-id="element-465">
                Motorway driving requires specific skills and confidence that
                many new drivers haven't had the opportunity to develop. Our
                specialized motorway lessons provide a safe, structured
                environment to learn these essential skills with an experienced
                instructor by your side.
              </p>
              <div className="bg-gray-50 p-6 rounded-lg" data-id="element-466">
                <h3 className="text-xl font-semibold mb-3" data-id="element-467">
                  What You'll Learn
                </h3>
                <ul className="space-y-2" data-id="element-468">
                  <li className="flex items-start" data-id="element-469">
                    <div className="mr-2 text-burgundy-600 mt-1" aria-hidden="true" data-id="element-470">
                      ✓
                    </div>
                    <div data-id="element-471">Safe entry and exit via slip roads</div>
                  </li>
                  <li className="flex items-start" data-id="element-472">
                    <div className="mr-2 text-burgundy-600 mt-1" aria-hidden="true" data-id="element-473">
                      ✓
                    </div>
                    <div data-id="element-474">Proper lane discipline and positioning</div>
                  </li>
                  <li className="flex items-start" data-id="element-475">
                    <div className="mr-2 text-burgundy-600 mt-1" aria-hidden="true" data-id="element-476">
                      ✓
                    </div>
                    <div data-id="element-477">Safe overtaking techniques</div>
                  </li>
                  <li className="flex items-start" data-id="element-478">
                    <div className="mr-2 text-burgundy-600 mt-1" aria-hidden="true" data-id="element-479">
                      ✓
                    </div>
                    <div data-id="element-480">Managing speed and maintaining safe distances</div>
                  </li>
                  <li className="flex items-start" data-id="element-481">
                    <div className="mr-2 text-burgundy-600 mt-1" aria-hidden="true" data-id="element-482">
                      ✓
                    </div>
                    <div data-id="element-483">Dealing with heavy traffic and adverse weather</div>
                  </li>
                </ul>
              </div>
            </div>
            <div data-id="element-484">
              <PackageCard title="Motorway Driving Lessons" price="£90" description="£45 per hour - 2-hour package for safe and structured lessons to build confidence on motorways." features={['Hands-on experience on actual motorways', 'Learn to manage high-speed driving situations', 'Develop awareness of motorway-specific hazards', 'Build confidence for independent motorway driving']} popular={true} link="https://www.totaldrive.app/a/enquiry_form.php?17584722727972" data-id="element-485" />
            </div>
          </div>
        </div>
        {/* Test Booking Section */}
        <div className="mb-16" data-id="element-486">
          <h2 className="text-2xl font-bold mb-6 border-b border-gray-200 pb-2" data-id="element-487">
            Driving Test Booking Service
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-488">
            <div data-id="element-489">
              <p className="mb-4" data-id="element-490">
                Booking your DVSA driving test can be difficult when slots are
                limited. Northampton Driving School provides a Driving Test
                Booking Service to manage the process for you.
              </p>
              <div className="bg-gray-50 p-6 rounded-lg" data-id="element-491">
                <h3 className="text-xl font-semibold mb-3" data-id="element-492">What's Included</h3>
                <ul className="space-y-2" data-id="element-493">
                  <li className="flex items-start" data-id="element-494">
                    <div className="mr-2 text-burgundy-600 mt-1" aria-hidden="true" data-id="element-495">
                      ✓
                    </div>
                    <div data-id="element-496">
                      Administrative handling of the DVSA test booking process
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-497">
                    <div className="mr-2 text-burgundy-600 mt-1" aria-hidden="true" data-id="element-498">
                      ✓
                    </div>
                    <div data-id="element-499">
                      Assistance in securing an available date and location
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-500">
                    <div className="mr-2 text-burgundy-600 mt-1" aria-hidden="true" data-id="element-501">
                      ✓
                    </div>
                    <div data-id="element-502">
                      Email confirmation once your test is successfully booked
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-503">
                    <div className="mr-2 text-burgundy-600 mt-1" aria-hidden="true" data-id="element-504">
                      ✓
                    </div>
                    <div data-id="element-505">DVSA test fee (£62) is included in the price</div>
                  </li>
                </ul>
                <h3 className="text-xl font-semibold mb-3 mt-6" data-id="element-506">
                  Important Notes
                </h3>
                <ul className="space-y-2" data-id="element-507">
                  <li className="flex items-start" data-id="element-508">
                    <div className="mr-2 text-amber-600 mt-1" aria-hidden="true" data-id="element-509">
                      !
                    </div>
                    <div data-id="element-510">
                      The £110 fee includes both our admin service and the DVSA
                      test fee (£62)
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-511">
                    <div className="mr-2 text-amber-600 mt-1" aria-hidden="true" data-id="element-512">
                      !
                    </div>
                    <div data-id="element-513">
                      This service does not include use of the instructor's car,
                      pre-test lessons, or test-day attendance
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-514">
                    <div className="mr-2 text-amber-600 mt-1" aria-hidden="true" data-id="element-515">
                      !
                    </div>
                    <div data-id="element-516">
                      Once the booking is made, this fee is non-refundable, even
                      if the DVSA cancels or reschedules the test (cancellation
                      charges apply)
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-517">
                    <div className="mr-2 text-amber-600 mt-1" aria-hidden="true" data-id="element-518">
                      !
                    </div>
                    <div data-id="element-519">
                      Northampton Driving School acts as a booking intermediary
                      to support students with the DVSA test process
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div data-id="element-520">
              <PackageCard title="Driving Test Booking Service" price="£110" description="Administrative booking support for securing your DVSA driving test date. Includes DVSA test fee (£62)." features={['We handle the test booking process', 'Help securing available test dates', 'Email confirmation of booking', 'DVSA test fee (£62) included']} link="https://www.totaldrive.app/a/enquiry_form.php?17584722727972" data-id="element-521" />
            </div>
          </div>
        </div>
        <div className="text-center" data-id="element-522">
          <h2 className="text-2xl font-bold mb-4" data-id="element-523">
            Ready to Enhance Your Skills?
          </h2>
          <p className="text-gray-700 mb-6 max-w-2xl mx-auto" data-id="element-524">
            Book your additional lessons today and build the confidence you need
            on the road.
          </p>
          <div className="max-w-3xl mx-auto mb-8" data-id="element-525">
            <BeforeYouBook data-id="element-526" />
          </div>
          <a href="https://www.totaldrive.app/a/enquiry_form.php?17584722727972" target="_blank" rel="noopener noreferrer" className="bg-burgundy-600 hover:bg-burgundy-700 text-white px-6 py-3 rounded-md font-medium inline-block transition-colors" aria-label="Book your additional driving lessons in Northampton" data-id="element-527">
            Book Now
          </a>
        </div>
      </div>
    </div>;
};
export default AdditionalLessonsPage;